webpackJsonp([137032230665884],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Section = __webpack_require__(7);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapAdditionalImage = function mapAdditionalImage(_ref, index) {
		var imageSrc = _ref.imageSrc,
		    imageSrc2x = _ref.imageSrc2x;
		return _react2.default.createElement("img", { key: index, className: "pictureSectionImg border-radius-small", src: imageSrc, srcSet: imageSrc2x + " 2x", style: { marginTop: 10 } });
	};
	
	var PictureSectionWithCaption = function PictureSectionWithCaption(_ref2) {
		var _ref2$className = _ref2.className,
		    className = _ref2$className === undefined ? "" : _ref2$className,
		    imageSrc = _ref2.imageSrc,
		    imageSrc2x = _ref2.imageSrc2x,
		    caption = _ref2.caption,
		    _ref2$additionalImage = _ref2.additionalImages,
		    additionalImages = _ref2$additionalImage === undefined ? [] : _ref2$additionalImage;
	
	
		var additionalImagesRendered = additionalImages.map(mapAdditionalImage);
		return _react2.default.createElement(
			_Section2.default,
			{ className: "pictureSection has-mobile-gutter " + className + " text-align-center" },
			_react2.default.createElement(
				"span",
				{ className: "caption title font-size-med" },
				caption
			),
			_react2.default.createElement(
				"div",
				{ className: "desktop-max-width-large text-align-center" },
				_react2.default.createElement("img", { className: "pictureSectionImg border-radius-small", src: imageSrc, srcSet: imageSrc2x + " 2x" }),
				additionalImagesRendered
			)
		);
	};
	
	PictureSectionWithCaption.propTypes = {
		className: _propTypes2.default.string,
		imageSrc: _propTypes2.default.string.isRequired,
		imageSrc2x: _propTypes2.default.string.isRequired
	};
	
	exports.default = PictureSectionWithCaption;
	module.exports = exports["default"];

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.RankMainContent = exports.RankIntroSection = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PictureSectionWithCaption = __webpack_require__(27);
	
	var _PictureSectionWithCaption2 = _interopRequireDefault(_PictureSectionWithCaption);
	
	var _BaseIntroSection = __webpack_require__(15);
	
	var _BaseIntroSection2 = _interopRequireDefault(_BaseIntroSection);
	
	var _hyr_ = __webpack_require__(355);
	
	var _hyr_2 = _interopRequireDefault(_hyr_);
	
	var _hyr_3 = __webpack_require__(356);
	
	var _hyr_4 = _interopRequireDefault(_hyr_3);
	
	var _hyr_5 = __webpack_require__(357);
	
	var _hyr_6 = _interopRequireDefault(_hyr_5);
	
	var _hyr_7 = __webpack_require__(358);
	
	var _hyr_8 = _interopRequireDefault(_hyr_7);
	
	var _hyr_9 = __webpack_require__(359);
	
	var _hyr_10 = _interopRequireDefault(_hyr_9);
	
	var _hyr_11 = __webpack_require__(360);
	
	var _hyr_12 = _interopRequireDefault(_hyr_11);
	
	var _hyr_13 = __webpack_require__(349);
	
	var _hyr_14 = _interopRequireDefault(_hyr_13);
	
	var _hyr_15 = __webpack_require__(350);
	
	var _hyr_16 = _interopRequireDefault(_hyr_15);
	
	var _hyr_17 = __webpack_require__(351);
	
	var _hyr_18 = _interopRequireDefault(_hyr_17);
	
	var _hyr_19 = __webpack_require__(352);
	
	var _hyr_20 = _interopRequireDefault(_hyr_19);
	
	var _hyr_21 = __webpack_require__(353);
	
	var _hyr_22 = _interopRequireDefault(_hyr_21);
	
	var _hyr_23 = __webpack_require__(354);
	
	var _hyr_24 = _interopRequireDefault(_hyr_23);
	
	__webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RedQuote = function RedQuote() {
		return _react2.default.createElement(
			"div",
			{ className: "redQuote text-align-center desktop-max-width-small font-family-open-sans-italic font-size-xlarge" },
			_react2.default.createElement(
				"div",
				{ className: "quote" },
				"\u201CThose [features] prompt you to really perfect your profile and build yourself up and make yourself appear how you want to be. So I see it as building yourself, your brand.\u201D"
			),
			"- LinkedIn Member"
		);
	};
	
	var RankIntroSection = exports.RankIntroSection = function RankIntroSection() {
		return _react2.default.createElement(
			_BaseIntroSection2.default,
			{
				className: "checkoutPage",
				mainText: "LinkedIn How You Rank",
				subText: "Helping our members stand out from the crowd and get found on LinkedIn",
				aboutText: "In 2014, LInkedIn\u2019s How You Rank was launched to be a compliment product to the very popular Who\u2019s Viewed your Profile tool and was designed as a Premium [paid] product. As an extension to the Who\u2019s Viewed My Profile tool, our goal was to help members see who might be getting more views in their industry, network, company, and get a better understanding of what may contribute to higher profile views. While developing the product, I worked closely with with Product Manager and UX Researcher to understand this space. The biggest challenge in this product was trying to create something meaningful and useful and at the same time, trying to not hurt member feelings if they happen to rank low but also provide insights what they can do to increase profile views."
			},
			_react2.default.createElement(RedQuote, null)
		);
	};
	
	var RankMainContent = exports.RankMainContent = function RankMainContent() {
		return [_react2.default.createElement(_PictureSectionWithCaption2.default, {
			imageSrc: _hyr_2.default,
			imageSrc2x: _hyr_14.default,
			className: "has-grey-background",
			key: 1
		}), _react2.default.createElement(_PictureSectionWithCaption2.default, {
			imageSrc: _hyr_4.default,
			imageSrc2x: _hyr_16.default,
			caption: "LinkedIn Premium upsell designs",
			additionalImages: [{
				imageSrc: _hyr_6.default,
				imageSrc2x: _hyr_18.default
			}, {
				imageSrc: _hyr_8.default,
				imageSrc2x: _hyr_20.default
			}],
			key: 2
		}), _react2.default.createElement(_PictureSectionWithCaption2.default, {
			imageSrc: _hyr_10.default,
			imageSrc2x: _hyr_22.default,
			caption: "Locked How you rank design",
			key: 3
		}), _react2.default.createElement(_PictureSectionWithCaption2.default, {
			imageSrc: _hyr_12.default,
			imageSrc2x: _hyr_24.default,
			caption: "Unlocked Premium version of How You Rank",
			key: 4
		})];
	};

/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_1.2e733478.jpg";

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_2.c6eaa5c8.jpg";

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_3.8e575187.jpg";

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_4.c68688c7.jpg";

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_5.e786e628.jpg";

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_6.fa7087b6.jpg";

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_1.76abd756.jpg";

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_2.f52d3370.jpg";

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_3.00e86368.jpg";

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_4.9adf384d.jpg";

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_5.33cc871a.jpg";

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hyr_6.7b12e0e4.jpg";

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BackToHomeHeader = __webpack_require__(14);
	
	var _BackToHomeHeader2 = _interopRequireDefault(_BackToHomeHeader);
	
	var _HowYouRankPageSections = __webpack_require__(131);
	
	var _Footer = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
		return [_react2.default.createElement(_BackToHomeHeader2.default, { key: "header", title: "How You Rank", company: "LinkedIn" }), _react2.default.createElement(_HowYouRankPageSections.RankIntroSection, { key: "introSection" }), _react2.default.createElement(_HowYouRankPageSections.RankMainContent, { key: "mainContent" }), _react2.default.createElement(_Footer.NextProjectFooter, { key: "homeFooter", href: "/playmemories" })];
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-how-you-rank-js-29689cd82421df8f23fd.js